// extracted by mini-css-extract-plugin
export default {"errorMessage":"commoninput_errorMessage__VeXYz"};